import { Box, css, styled } from '@mui/material'

export const StyledContainer = styled(Box)`
  ${({ isHighlighted }: { isHighlighted: boolean }) =>
    isHighlighted
      ? css`
          background-color: #d1e8f5;
          padding: 10px 6px 10px 10px;
        `
      : ''};
`
